export function assert(condition, msg = "Assertion failed") {
    if (!condition) {
        throw new Error(msg);
    }
}
export function invariant(input, msg) {
    assert(input !== undefined && input !== null, msg);
}
